import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

function FaqItem({ pergunta, resposta, index, isOpen, onToggle }) {
  return (
    <div
      className="bg-[#111111] border border-white/5 rounded-xl overflow-hidden transition-colors hover:border-white/10"
      data-testid={`faq-item-${index}`}
    >
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between gap-4 p-5 md:p-6 text-left hover:bg-white/[0.02] transition-colors"
        aria-expanded={isOpen}
      >
        <span className="text-base md:text-lg font-medium text-white">
          {pergunta}
        </span>
        <ChevronDown
          className={`flex-shrink-0 w-5 h-5 text-zinc-400 transition-transform duration-300 ${
            isOpen ? "rotate-180" : ""
          }`}
        />
      </button>
      <div
        className={`grid transition-all duration-300 ease-out ${
          isOpen
            ? "grid-rows-[1fr] opacity-100"
            : "grid-rows-[0fr] opacity-0"
        }`}
      >
        <div className="overflow-hidden">
          <p className="px-5 md:px-6 pb-5 md:pb-6 text-zinc-400 leading-relaxed">
            {resposta}
          </p>
        </div>
      </div>
    </div>
  );
}

export default function Faq({ conteudo, onTrocarNicho }) {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section
      id="faq"
      className="py-12 md:py-28 px-4 md:px-6"
      data-testid="faq"
    >
      <div className="max-w-3xl mx-auto">
        <div className="flex flex-col items-center text-center gap-3 mb-10 md:mb-14">
          <span className="text-xs md:text-sm font-semibold text-green-400 uppercase tracking-[0.18em]">
            Perguntas frequentes
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-extrabold text-white tracking-tight">
            Dúvidas comuns
          </h2>
          <p className="text-base md:text-lg text-zinc-400">
            As dúvidas mais comuns de quem tem {conteudo.nome} —{" "}
            <button
              type="button"
              onClick={onTrocarNicho}
              className="text-green-400 hover:text-green-300 font-medium underline underline-offset-2 bg-transparent border-0 p-0 cursor-pointer"
            >
              veja outro segmento
            </button>
            .
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {conteudo.faq.map((q, i) => (
            <FaqItem
              key={`${conteudo.slug}-${i}`}
              index={i}
              pergunta={q.pergunta}
              resposta={q.resposta}
              isOpen={openIndex === i}
              onToggle={() => setOpenIndex(openIndex === i ? -1 : i)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
